import React from 'react';
import PropTypes from "prop-types";
import { GoogleMapContext } from "../GoogleMap";
import { createMarker, createLatLng } from "../../google";

export default class Marker extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    iconURL: PropTypes.string.isRequired,
  };

  static contextType = GoogleMapContext;

  componentDidMount() {
    this.marker = createMarker({
      map: this.context,
      latitude: this.props.latitude,
      longitude: this.props.longitude,
      title: this.props.title,
      iconURL: this.props.iconURL,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.marker.setTitle(nextProps.title);
    this.marker.setIcon(nextProps.iconURL);
    this.marker.setPosition(createLatLng(nextProps.latitude, nextProps.longitude));
  }

  render() {
    return null;
  }
}
